module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "vue-dropzone dropzone",
    attrs: {
      "action": _vm.url,
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22a0c408!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Dropzone.vue
// module id = 2334
// module chunks = 1